// @file Helper utilities for Metabase embed URLs and analytics CSV downloads
import type { LibraryAnalytics, TenantAnalytics } from '@@/types'

type Analytics = TenantAnalytics | LibraryAnalytics

const parseAnalytics = (analytics: Analytics, darkMode: boolean): Analytics => {
  const parsedAnalytics = { ...analytics }
  for (const key in parsedAnalytics) {
    let embedLink = parsedAnalytics[key]
    if (embedLink !== null) {
      const url = new URL(embedLink)
      /**
       * Metabase receives the appearance parameters
       * through the hash instead of the URL query params.
       */
      url.hash = new URLSearchParams({
        bordered: 'false',
        titled: 'false',
        theme: darkMode ? 'night' : 'transparent',
        downloads: 'false',
      }).toString()
      embedLink = url.toString()
    }
    parsedAnalytics[key] = embedLink
  }
  return parsedAnalytics
}

/**
 * Builds a CSV download URL for tenant analytics.
 * The backend builds the Metabase URL server-side and prepends a UTF-8 BOM for Excel.
 *
 * @see https://github.com/metabase/metabase/issues/3271
 */
const getTenantAnalyticsCsvDownloadUrl = (tenantId: number): string => {
  return `/api/5/tenants/${tenantId}/analytics/csv`
}

/**
 * Builds a CSV download URL for library analytics.
 * The backend builds the Metabase URL server-side and prepends a UTF-8 BOM for Excel.
 *
 * @see https://github.com/metabase/metabase/issues/3271
 */
const getLibraryAnalyticsCsvDownloadUrl = (libraryId: number): string => {
  return `/api/5/libraries/${libraryId}/analytics/csv`
}
export { parseAnalytics, getTenantAnalyticsCsvDownloadUrl, getLibraryAnalyticsCsvDownloadUrl }
